// src/store/index.ts
import { configureStore } from "@reduxjs/toolkit";
import shopReducer from "./slices/shopSlice";
import authReducer from "./slices/authSlice";
import availabilityReducer from "./slices/availabilitySlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    shop: shopReducer,
    availability: availabilityReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;